export default __webpack_public_path__ + "static/media/proj-dishita.e224c238.jpg";